/* 會員相關接口 */

import request from '@/utils/http/request'



/* List */
export async function fetchAll({ barCode, itemName, itemCode, sDate, eDate, exp, page, pageSize }) {
    return await request.post('/product/receipt', {
        barCode, itemName, itemCode, sDate, eDate, exp, page, pageSize
    }, {
        noAuth: false
    });
}

export async function fetch({ id }) {
    return await request.post('/product/receipt/fetch', {
        id
    }, {
        noAuth: false
    });
}

export async function pageExport({ barCode, itemName, itemCode, sDate, eDate, exp }) {
    return await request.post('/product/receipt', { barCode, itemName, itemCode, sDate, eDate, exp },
        {
            responseType: 'blob',
            noAuth: false
        }

    );
}



export async function store({ barCode, itemCode, itemName }) {
    return await request.post('/product/receipt/store', {
        barCode, itemCode, itemName
    }, {
        noAuth: false
    });
}



export async function update(data) {
    return await request.post('/product/receipt/update', data, {
        noAuth: false
    });
}



export async function infoByBarCode({ barCode }) {
    return await request.post('/product/receipt/infobybarcode', {
        barCode
    }, {
        noAuth: false
    });
}








